import * as React from 'react'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'

import FitScale from './FitScale'
import { ComponentWrapper, Heading, Label, LabelsWrapper } from './styles'

const useAverageFitTexts = () => {
  const translations = useTranslation()
  return translations.magnolia.reviewsPage.averageFit
}

export const AverageFit: React.FC<{
  fit: number
  className?: string
}> = ({ className, fit }) => {
  const averageFitTexts = useAverageFitTexts()

  return (
    <ComponentWrapper className={className}>
      <Heading>{averageFitTexts.averageFit}</Heading>
      <FitScale fit={Math.round(fit)} />
      <LabelsWrapper>
        <Label>{averageFitTexts.tooSmall}</Label>
        <Label>{averageFitTexts.trueToSize}</Label>
        <Label>{averageFitTexts.tooBig}</Label>
      </LabelsWrapper>
    </ComponentWrapper>
  )
}
